"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _currency = require("../../currency");
var _Toggle = _interopRequireDefault(require("../helpers/Toggle"));
var _Modal = _interopRequireDefault(require("../Modal"));
var _constants = require("../constants");
var _List = _interopRequireDefault(require("../List/List"));
var _Default = _interopRequireDefault(require("./templates/Default"));
var _Icon = _interopRequireDefault(require("./templates/Icon"));
var _envConstants = require("../../env-constants");
var _analytics = require("../../helpers/analytics");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var templates = {
  Default: _Default["default"],
  Icon: _Icon["default"]
};
var getLabel = function getLabel() {
  var currency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'EUR';
  var shrunk = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var symbol;
  if (typeof Intl === 'undefined' || !Intl.NumberFormat) {
    console.warn('Intl is not found, using simple polyfill');
    switch (currency) {
      case 'GBP':
        symbol = '£';
        break;
      case 'USD':
        symbol = '$';
        break;
      case 'AUD':
        symbol = 'A$';
        break;
      case 'CAD':
        symbol = 'CA$';
        break;
      default:
        symbol = '€';
    }
  } else {
    var str = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency
    }).format(0);
    symbol = str.split('0')[0];
  }
  return shrunk ? symbol : "".concat(currency, " - ").concat(symbol);
};
var CurrencyDropdown = function CurrencyDropdown(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    hasOneSupportedCurrency = _useState2[0],
    setHasOneSupportedCurrency = _useState2[1];
  var context = (0, _react.useContext)(_currency.CurrencyContext);
  (0, _react.useEffect)(function () {
    return setHasOneSupportedCurrency(props.supportedCurrencies.length === 1);
  }, [props.supportedCurrencies]);
  (0, _react.useEffect)(function () {
    if (hasOneSupportedCurrency) {
      context.changeCurrency(props.supportedCurrencies[0]);
    }
  }, [hasOneSupportedCurrency]);
  if (['tsw', 'qd'].includes(_envConstants.ENV.SITE)) {
    return null;
  }
  var TemplateSelected = templates[props.template];
  return /*#__PURE__*/_react["default"].createElement(_Toggle["default"], null, function (_ref) {
    var on = _ref.on,
      toggle = _ref.toggle;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(TemplateSelected, (0, _extends2["default"])({}, props, {
      className: "".concat(props.className),
      context: context,
      toggle: !hasOneSupportedCurrency ? toggle : null,
      getLabel: getLabel
    })), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
      on: on,
      toggle: toggle
    }, /*#__PURE__*/_react["default"].createElement(_List["default"], {
      heading: "Choose a Currency",
      items: props.supportedCurrencies.map(function (c) {
        return {
          className: _analytics.GA4_TRIGGERS.CHANGED_CURRENCY_CLASS,
          isSelected: (context === null || context === void 0 ? void 0 : context.currency) === c,
          title: getLabel(c),
          onClick: function onClick() {
            context.changeCurrency(c);
            toggle();
          }
        };
      })
    })));
  });
};
CurrencyDropdown.propTypes = {
  supportedCurrencies: _propTypes["default"].array,
  buttonType: _propTypes["default"].string,
  shrinkMobile: _propTypes["default"].bool,
  template: _propTypes["default"].string
};
CurrencyDropdown.defaultProps = {
  supportedCurrencies: _constants.SUPPORTED_CURRENCIES,
  buttonType: _constants.BUTTON_TYPES.WHITE,
  shrinkMobile: false,
  template: 'Default'
};
var _default = exports["default"] = CurrencyDropdown;